export enum MessageAuthorEnum {
  AI = 'ai_assistant',
  VISITOR = 'visitor',
  HUMAN_OPERATOR = 'human_operator',
}
